import { render, staticRenderFns } from "./LastFeedbacks.vue?vue&type=template&id=422bd4b3&"
import script from "./LastFeedbacks.vue?vue&type=script&lang=js&"
export * from "./LastFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports